import { render, staticRenderFns } from "./MeetRoomAttachments.vue?vue&type=template&id=52e8996e&scoped=true"
import script from "./MeetRoomAttachments.vue?vue&type=script&lang=js"
export * from "./MeetRoomAttachments.vue?vue&type=script&lang=js"
import style0 from "./MeetRoomAttachments.vue?vue&type=style&index=0&id=52e8996e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8996e",
  null
  
)

export default component.exports